import React, { useState, useEffect } from "react";
import { useAppContext } from "./../../components/Context";

//import components
import Filter from "../../components/dynamic/Filter";

//import tags
import parse from "html-react-parser";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, A11y } from "swiper/modules";
import { Link, useParams, useLocation } from "react-router-dom";
import { Container, Row, Col, Image } from "react-bootstrap";
import Skeleton from "react-loading-skeleton";
import { toast } from 'react-toastify';

//import resources
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faList,
  faTableCellsLarge,
  faHeart,
  faLocationCrosshairs,
  faBed,
  faDoorOpen,
  faLayerGroup,
  faChevronDown,
  faArrowLeft,
  faArrowRight,
} from "@fortawesome/free-solid-svg-icons";
import {
  faHeart as faHeartRegular,
  faClone,
} from "@fortawesome/free-regular-svg-icons";

import "swiper/css";
import "swiper/css/navigation";

import Noproperty from "../../assets/image/property.jpg";

//import translation
import { useTranslation } from "react-i18next";
import "../../i18n";

//api
import { get_property } from "../../api/Api";

function Main({locale}) {
  const baseUrl = "https://api.relux.ge";

  const { getenumbykey, setFavoritesCount } = useAppContext();

  //get locale
  const { t } = useTranslation();

  const { id, slug } = useParams();
  const location = useLocation();

  const [property, setProperty] = useState(false);
  const [toggleView, setToggleView] = useState("grid");
  const [favorites, setFavorites] = useState([]);
  const [message, setMessage] = useState("");
  const [currentCurrency, setCurrentCurrency] = useState("GEL");

  const [totalPages, setTotalPages] = useState(null);


  const [page, setPage] = useState(1);
  const [queryData, setQueryData] = useState({});

  const queryParams = new URLSearchParams(window.location.search);

  const sortBy = (e) => {
    setQueryData((prevQueryData)=>({
      ...prevQueryData,
      "sort": e.target.value
    }));
  }

  useEffect(() => {
    setQueryData((prevQueryData)=>({
      ...prevQueryData,
      "page": page
    }));
  }, [page]);


  useEffect(() => {
    const newQueryData = {};
  
    queryParams.forEach((value, key) => {
      newQueryData[key] = value.includes(",") ? value.split(",") : value;
    });

  
    setQueryData((prevQueryData) => ({
      ...prevQueryData,
      ...newQueryData,
    }));
  }, [location.search]);


  useEffect(() => {
    if (Object.keys(queryData).length > 0) {
      updateQueryParams(queryData);
    }
  }, [queryData]);
  


  //filter function to add items to filter array and send to get parameter in url
  const updateQueryParams = (queryData) => {
    
    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams();
  
    Object.keys(queryData).forEach(key => {
      const value = queryData[key];
      if (Array.isArray(value)) {
        searchParams.set(key, value.join(','));
      } else if (value !== undefined && value !== null && value !== '') {
        searchParams.set(key, value);
      }
    });
  
    url.search = searchParams.toString();
    window.history.replaceState({}, '', url.toString());

  };
  
  //fetch api data
  useEffect(() => {

    setProperty(false);

    const fetchData = async () => {
      try {
        get_property(setProperty, queryData);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if(queryData?.page > 0) {
      fetchData();
    }
    
  }, [queryData]);

  //total pages

  useEffect(() => {
    if (typeof property == "object") {
      setTotalPages(property?.total / property?.per_page);
    }
  }, [property]);


  //change view of property
  const toggleViewHandler = () => {
    setToggleView((prevView) => {
      const newView = prevView === "grid" ? "list" : "grid";
      localStorage.setItem("view", newView);
      return newView;
    });
  };

  //get view from localstorage if exist

  useEffect(() => {
    if (localStorage.hasOwnProperty("view")) {
      setToggleView(localStorage.getItem("view"));
    }
  }, []);


  //get favorites if saved

  useEffect(() => {
    const storedFavorites = JSON.parse(localStorage.getItem("favorites")) || [];
    setFavorites(storedFavorites);
  }, []);

  //set favorites
  const toggleFavorite = (id) => {
    let updatedFavorites;

    if (favorites.includes(id)) {
      updatedFavorites = favorites.filter((favId) => favId !== id);
      toast.error(t('removed_from_fav'), {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    } else {
      updatedFavorites = [...favorites, id];
      toast.success(t('added_to_fav'), {
        position: "bottom-right",
        autoClose: 3000,
        hideProgressBar: false,
        closeOnClick: false,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "colored",
      });
    }

    setFavorites(updatedFavorites);

    localStorage.setItem("favorites", JSON.stringify(updatedFavorites));
  };

  //toggle currency
  const toggleCurrency = (currency) => {
    setCurrentCurrency(currency);
  };

  //set favorites count context
  useEffect(() => {
    setFavoritesCount(null);
  }, [favorites]);
 


  return (
    <>
      <div className="main">
        <section className="productSection">
          <Container>
            <Row>
              
              <Filter setQueryData={setQueryData} queryData={queryData} queryParams={queryParams} />

              <Col xxl={12}>
                <div className="productCard mainProducts">
                  <div className="productCardTopSortBox">
                    <div className="productCardTopSortBoxLeft">
                      <h4>
                        {t('found')} {" "}
                        <span>
                          {typeof property === "object" ? property.total : 0}
                        </span>{" "}
                        {t('statement')}
                      </h4>
                    </div>
                    <div className="productCardTopSortBoxRight">
                      <div className="form-group sortBYButton">
                        <select
                          value={queryData?.sort || ''}
                          onChange={(e) => sortBy(e)}
                          className="form-control"
                        >
                          <option value="">{t('sort')}</option>
                          <option value="price_gel~asc">{t('price_asc')}</option>
                          <option value="price_gel~desc">
                            {t('price_desc')}
                          </option>
                          <option value="created_at~asc">
                            {t('date_asc')}
                          </option>
                          <option value="created_at~desc">
                            {t('date_desc')}
                          </option>
                        </select>
                        <FontAwesomeIcon icon={faChevronDown} />
                      </div>

                      <div
                        className="changeViewButton"
                        onClick={() => toggleViewHandler()}
                      >
                        {toggleView == "grid" ? (
                          <FontAwesomeIcon
                            title="Grid view"
                            icon={faTableCellsLarge}
                          />
                        ) : (
                          <FontAwesomeIcon title="List view" icon={faList} />
                        )}
                      </div>
                    </div>
                  </div>
                  <Row>
                    {typeof property === "object" ? (
                      property.data.map(function (item) {
                        return (
                          <div
                            className={
                              toggleView == "grid"
                                ? "gridView col-xxl-3"
                                : "listView col-xxl-12"
                            }
                            key={item.id}
                          >
                            <div className="singleProductGridBox">
                              {message && (
                                <div className="addedToFavourites">
                                  <h4>{message}</h4>
                                </div>
                              )}
                              <div className="singleProductGridBoxImageBox">
                                <Link to={`/${locale}/property/details/` + item.id}>
                                  <Swiper
                                    modules={[Navigation, A11y]}
                                    spaceBetween={5}
                                    slidesPerView={1}
                                    navigation
                                    scrollbar={{ draggable: true }}
                                  >
                                    {item.image1 && item.image1 != null ? (
                                      <SwiperSlide>
                                        <div className="singleProductGridBoxImage">
                                          <Image
                                            src={`${baseUrl}/storage/property/${item.image_folder}/thumbnail/${item.image1}`}
                                            alt={`${
                                              typeof item === "object" &&
                                              item?.transaction_type != null
                                                ? getenumbykey(
                                                    parse(item.transaction_type), 'transaction_type'
                                                  )
                                                : ""
                                            } ${
                                              typeof item === "object" &&
                                              item?.property_type != null
                                                ? getenumbykey(
                                                    parse(item.property_type), 'property_type'
                                                  )
                                                : ""
                                            }`}
                                          />
                                        </div>
                                      </SwiperSlide>
                                    ) : (
                                      <SwiperSlide>
                                        <div className="singleProductGridBoxImage">
                                          <Image src={Noproperty} alt="Relux" />
                                        </div>
                                      </SwiperSlide>
                                    )}
                                  </Swiper>
                                </Link>
                                {item.statement_type && (
                                  <div
                                    className={`singleProductGridTag ${
                                      item.statement_type === "exclusive"
                                        ? "exclusiveAd"
                                        : "reluxAd"
                                    }`}
                                  >
                                    <Link to="/">
                                      <h4>
                                        {item?.statement_type != null
                                          ? getenumbykey(
                                              parse(item.statement_type), 'statement_type'
                                            )
                                          : ""}
                                      </h4>
                                    </Link>
                                  </div>
                                )}
                                <div
                                  className="singleProductGridFavourite"
                                  onClick={() => toggleFavorite(item.id)}
                                >
                                  {favorites.includes(item.id) ? (
                                    <FontAwesomeIcon icon={faHeart} />
                                  ) : (
                                    <FontAwesomeIcon icon={faHeartRegular} />
                                  )}
                                </div>
                              </div>
                              <div className="singleProductGridBoxContant">
                                <div className="singleProductGridPrice">
                                  {["GEL", "USD", "EUR"].includes(
                                    currentCurrency
                                  ) && (
                                    <h4>
                                      {item?.[
                                        `price_${currentCurrency.toLowerCase()}`
                                      ] != null
                                        ? item[
                                            `price_${currentCurrency.toLowerCase()}`
                                          ]
                                        : ""}
                                      <span>{currentCurrency}</span>
                                    </h4>
                                  )}
                                  <div className="priceBoxGrid">
                                    {["GEL", "USD", "EUR"].map((currency) => (
                                      <div
                                        key={currency}
                                        className={`singlePrice ${
                                          currentCurrency === currency
                                            ? "active"
                                            : ""
                                        }`}
                                        onClick={() => toggleCurrency(currency)}
                                      >
                                        <p>{currency}</p>
                                      </div>
                                    ))}
                                  </div>
                                </div>
                                <div className="propertyGridTags">
                                  <div className="singleTag">
                                    {item?.property_type != null
                                      ? getenumbykey(parse(item.property_type), 'property_type')
                                      : ""}
                                  </div>
                                  <div className="singleTag">
                                    {item?.city != null
                                      ? getenumbykey(parse(item.city), 'city')
                                      : ""}
                                  </div>
                                </div>
                                <Link to={`/${locale}/property/details/` + item.id}>
                                  <h1>
                                    {item?.transaction_type != null
                                      ? getenumbykey(
                                          parse(item.transaction_type), 'transaction_type'
                                        )
                                      : ""}{" "}
                                    {item?.property_type != null
                                      ? getenumbykey(parse(item.property_type), 'property_type')
                                      : ""}
                                  </h1>
                                </Link>
                                {toggleView == "list" ? (
                                  <div className="listItemDescription">
                                    {item?.translations[0]?.text != null
                                      ? parse(item?.translations[0]?.text)
                                      : ""}
                                  </div>
                                ) : null}

                                <div className="singlePropertyGridLocation">
                                  <FontAwesomeIcon
                                    icon={faLocationCrosshairs}
                                  />
                                  <p>
                                    {item?.address != null
                                      ? item.address.length > 50
                                        ? item.address
                                            .substring(0, 50)
                                            .replace(/<[^>]*>/g, "") + "..."
                                        : item.address.replace(/<[^>]*>/g, "")
                                      : ""}
                                  </p>
                                </div>
                                <div className="singlePropertyListMiniBox">
                                  {(() => {
                                    switch (item?.property_type) {
                                      case "land":
                                        return (
                                          <div
                                            className="singlePropertyGridMini"
                                            title={t('area')}
                                          >
                                            <FontAwesomeIcon icon={faClone} />:
                                            <span>
                                              {item?.area != null
                                                ? item.area
                                                : ""}{" "}
                                              მ<sup>2</sup>
                                            </span>
                                          </div>
                                        );
                                      case "apartment":
                                        return (
                                          <>
                                            <div
                                              className="singlePropertyGridMini"
                                              title={t('bedroom')}
                                            >
                                              <FontAwesomeIcon icon={faBed} />:
                                              <span>
                                                {item?.bedrooms != null
                                                  ? item.bedrooms
                                                  : ""}
                                              </span>
                                            </div>
                                            <div
                                              className="singlePropertyGridMini"
                                              title={t('room')}
                                            >
                                              <FontAwesomeIcon
                                                icon={faDoorOpen}
                                              />
                                              :
                                              <span>
                                                {item?.rooms != null
                                                  ? item.rooms
                                                  : ""}
                                              </span>
                                            </div>
                                            <div
                                              className="singlePropertyGridMini"
                                              title={t('floor')}
                                            >
                                              <FontAwesomeIcon
                                                icon={faLayerGroup}
                                              />
                                              :
                                              <span>
                                                {item?.floor != null
                                                  ? item.floor
                                                  : ""}
                                              </span>
                                            </div>
                                            <div
                                              className="singlePropertyGridMini"
                                              title={t('area')}
                                            >
                                              <FontAwesomeIcon icon={faClone} />
                                              :
                                              <span>
                                                {item?.area != null
                                                  ? item.area
                                                  : ""}{" "}
                                                მ<sup>2</sup>
                                              </span>
                                            </div>
                                          </>
                                        );
                                      case "business":
                                        return (
                                          <>
                                            <div
                                              className="singlePropertyGridMini"
                                              title={t('area')}
                                            >
                                              <FontAwesomeIcon icon={faClone} />
                                              :
                                              <span>
                                                {item?.area != null
                                                  ? item.area
                                                  : ""}{" "}
                                                მ<sup>2</sup>
                                              </span>
                                            </div>
                                            <div
                                              className="singlePropertyGridMini"
                                              title={t('room')}
                                            >
                                              <FontAwesomeIcon
                                                icon={faDoorOpen}
                                              />
                                              :
                                              <span>
                                                {item?.rooms != null
                                                  ? item.rooms
                                                  : ""}
                                              </span>
                                            </div>
                                          </>
                                        );
                                      default:
                                        return null;
                                    }
                                  })()}
                                </div>
                              </div>
                            </div>
                          </div>
                        );
                      })
                    ) : (
                      <>
                        <Col xl={3}>
                          <div className="singleProductGridBox">
                            <div className="singleProductGridBoxImageBox">
                              <Skeleton height={240} />
                            </div>
                            <div className="singleProductGridBoxContant">
                              <h1 className="mt-3">
                                <Skeleton height={25} />
                              </h1>
                              <Skeleton className="mt-3" height={20} />
                              <Skeleton className="mt-3" height={20} />
                            </div>
                          </div>
                        </Col>
                        <Col xl={3}>
                          <div className="singleProductGridBox">
                            <div className="singleProductGridBoxImageBox">
                              <Skeleton height={240} />
                            </div>
                            <div className="singleProductGridBoxContant">
                              <h1 className="mt-3">
                                <Skeleton height={25} />
                              </h1>
                              <Skeleton className="mt-3" height={20} />
                              <Skeleton className="mt-3" height={20} />
                            </div>
                          </div>
                        </Col>
                        <Col xl={3}>
                          <div className="singleProductGridBox">
                            <div className="singleProductGridBoxImageBox">
                              <Skeleton height={240} />
                            </div>
                            <div className="singleProductGridBoxContant">
                              <h1 className="mt-3">
                                <Skeleton height={25} />
                              </h1>
                              <Skeleton className="mt-3" height={20} />
                              <Skeleton className="mt-3" height={20} />
                            </div>
                          </div>
                        </Col>
                        <Col xl={3}>
                          <div className="singleProductGridBox">
                            <div className="singleProductGridBoxImageBox">
                              <Skeleton height={240} />
                            </div>
                            <div className="singleProductGridBoxContant">
                              <h1 className="mt-3">
                                <Skeleton height={25} />
                              </h1>
                              <Skeleton className="mt-3" height={20} />
                              <Skeleton className="mt-3" height={20} />
                            </div>
                          </div>
                        </Col>
                      </>
                    )}

                    <div className="col-xxl-12 mt-5">
                      <div className="pagination">
                        <button
                          onClick={
                            queryData?.page > 1
                              ? () => setPage(parseInt(queryData?.page) - 1)
                              : null
                          }
                          disabled={queryData?.page <= 1}
                          className="pagination-button paginatePrev"
                        >
                          <FontAwesomeIcon icon={faArrowLeft} />
                        </button>
                        <div className="pagination-pages paginateMiddle">
                          {typeof totalPages === "number" && totalPages > 0
                            ? Array.from(
                                { length: Math.ceil(totalPages) },
                                (_, index) => (
                                  <div
                                    key={index}
                                    onClick={() => setPage(index + 1)}
                                    className={
                                      "pagination-page paginateSingle " +
                                      (index + 1 === parseInt(queryData?.page)
                                        ? "active"
                                        : "")
                                    }
                                  >
                                    {index + 1}
                                  </div>
                                )
                              )
                            : ""}
                        </div>
                        <button
                          className="pagination-button paginateNext"
                          onClick={
                            queryData?.page < Math.ceil(totalPages)
                              ? () => setPage(parseInt(queryData?.page) + 1)
                              : null
                          }
                          disabled={queryData?.page > Math.ceil(totalPages)}
                        >
                          <FontAwesomeIcon icon={faArrowRight} />
                        </button>
                      </div>
                    </div>
                  </Row>
                </div>
              </Col>
            </Row>
          </Container>
        </section>
      </div>
    </>
  );
}

export default Main;
